import React, { useContext, useState } from 'react';
import { AppContext } from '../main';
import { EditModal } from '../pages/home';
// import { EditModal } from '../pages/home';


const marqueeLocations = [
  'London', 'Paris', 'Frankfurt', 'Amsterdam', 'Stockholm', 'Helsinki',
  'Los Angeles', 'Quebec', 'Singapore', 'Sydney', 'Sao Paulo', 'Bangkok', 'Jakarta'
];

const MapHotspot = ({ name, top, left }) => {
  const {
    appState,
    setAppState
  } = useContext(AppContext);
  const { editMode = false } = appState



  return <div className="de-spot fadeIn" style={{ top, left }}>
    <span>{name}</span>
    <div className="de-circle-1"></div>
    <div className="de-circle-2"></div>
  </div>
};

const Sectionloc = (props) => {
  const {
    appState,
    setAppState
  } = useContext(AppContext);
  const [modalOpen, setModalOpen] = useState(false);

  const {
    serverLocations = [],
    editItemMain = {}
  } = appState

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="subtitle fadeInUp mb-3">Our locations</div>
          </div>
          <div className="col-lg-6">
            <h2 className="fadeInUp mb20">25 servers available worldwide for your game.</h2>
          </div>
          <div className="col-lg-6">
            Take advantage of our server location testing tool to ensure optimal performance.
            Since your users are spread across various locations, it&apos;s important to identify
            the server location that provides the best experience for your members.
            Our ping tester can help you determine the ideal server location for your specific needs.
          </div>

          <div className="spacer-10"></div>
          <div className="col-lg-12 fadeInUp">
            <div className="p-sm-30 pb-sm-0 mb-sm-0">
              <div className="de-map-hotspot">
                {serverLocations.map((location) => (<>
                  <MapHotspot key={location.name} {...location} />
                </>
                ))}
                <img src="./img/misc/world-map.webp" className="img-fluid" alt="World Map" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="no-bottom wow fadeInRight d-flex z-1000">
        <div className="de-marquee-list wow">
          <div className="d-item">
            {marqueeLocations.map((location, index) => (
              <React.Fragment key={index}>
                <span className="d-item-txt">{location}</span>
                <span className="d-item-display">
                  <i className="d-item-block"></i>
                </span>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sectionloc;
